export default function () {
	const form = document.getElementById('footer-newsletter-form');
	if (!form) return;

	form.addEventListener('submit', function (e) {
		e.preventDefault();

		const emailInput = document.getElementById('footer-newsletter-email');
		const messageEl   = form.querySelector('.footer__form-message');
		const button      = form.querySelector('button[type="submit"]');
		const nonce       = form.querySelector('#footer_newsletter_nonce').value;

		messageEl.textContent = '';
		messageEl.classList.remove('is-error', 'is-success');

		if (!emailInput.value || !emailInput.checkValidity()) {
			messageEl.textContent = 'Please enter a valid email address.';
			messageEl.classList.add('is-error');
			return;
		}

		button.disabled = true;
		button.textContent = 'Submitting...';

		const formData = new FormData();
		formData.append('action', 'footer_newsletter_signup');
		formData.append('nonce', nonce);
		formData.append('email', emailInput.value);

		fetch(window.clickCreativeData.ajaxUrl, {
			method: 'POST',
			body: formData,
		})
			.then((res) => res.json())
			.then((data) => {
				messageEl.textContent = data.data.message;
				messageEl.classList.add(data.success ? 'is-success' : 'is-error');
				if (data.success) {
					form.reset();
				}
			})
			.catch(() => {
				messageEl.textContent = 'Something went wrong. Please try again.';
				messageEl.classList.add('is-error');
			})
			.finally(() => {
				button.disabled = false;
				button.textContent = 'Submit';
			});
	});
}